export const CardVideo = {
  bindings: {
    durationInMins: '<',
    heading: '<',
    image: '<',
    isFavourite: '<',
    onClick: '&',
    onFavourite: '&',
  },

  template: `
    <div class="card-video card-wrapper pointer"
      id="{{ $ctrl.heading | kebabCase }}">
      <card
        heading="$ctrl.heading"
        img="$ctrl.image"
        is-favourite="$ctrl.isFavourite"
        on-click="$ctrl.onClick()"
        on-favourite="$ctrl.onFavourite()">
        <badges>
          <button-play></button-play>
        </badges>
        <footer-left ng-if="$ctrl.durationInMins >= 0">
          <i class="icon icon-time"></i>
          <span>{{ $ctrl.durationInMins }} min</span>
        </footer-left>
      </card>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Card/CardVideo.js